import Highcharts from "highcharts"
import HighchartsReact from "highcharts-react-official";
import { useMemo, useEffect, useState } from "react";
import { useTheme } from "../../../context/ThemeContext";

interface EloChartProps {
  data: Array<number | [number, number] | { x?: number; y?: number; name?: string }>;
}

interface ThemeColors {
  bgSecondary: string;
  textPrimary: string;
  textMuted: string;
  accentSecondary: string;
  borderColor: string;
}

function EloChart(props: EloChartProps) {
  const { theme } = useTheme();
  const [colors, setColors] = useState<ThemeColors>({
    bgSecondary: '#0A0A0A',
    textPrimary: '#FFFFFF',
    textMuted: '#AAAAAA',
    accentSecondary: 'lightgreen',
    borderColor: '#333333',
  });

  useEffect(() => {
    const timer = setTimeout(() => {
      const root = document.documentElement;
      const styles = getComputedStyle(root);
      setColors({
        bgSecondary: styles.getPropertyValue('--bg-secondary').trim() || '#0A0A0A',
        textPrimary: styles.getPropertyValue('--text-primary').trim() || '#FFFFFF',
        textMuted: styles.getPropertyValue('--text-muted').trim() || '#AAAAAA',
        accentSecondary: styles.getPropertyValue('--accent-secondary').trim() || 'lightgreen',
        borderColor: styles.getPropertyValue('--border-color').trim() || '#333333',
      });
    }, 50);
    return () => clearTimeout(timer);
  }, [theme]);

  const options: Highcharts.Options = useMemo(() => ({
    chart: {
      type: "spline",
      backgroundColor: colors.bgSecondary,
      height: 250,
    },
    title: {
      text: "",
      style: {
        color: colors.textPrimary
      }
    },
    series: [
      {
        type: "spline",
        data: props.data,
        name: "Elo rating"
      }
    ],
    colors: [colors.accentSecondary],
    legend: { enabled: false },
    xAxis: {
      visible: false,
      lineColor: colors.borderColor,
      tickColor: colors.borderColor
    },
    yAxis: {
      title: { text: "" },
      gridLineColor: colors.borderColor,
      labels: {
        style: {
          color: colors.textMuted,
          font: '11px Trebuchet MS, Verdana, sans-serif'
        }
      },
    },
    credits: {
      enabled: false
    },
    plotOptions: {
      spline: {
        marker: {
          enabled: false
        }
      }
    }
  }), [props.data, colors]);

  return <HighchartsReact highcharts={Highcharts} options={options} />
}

export default EloChart
